<template>
  <div class="animated revealUp">
      
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title mb-3">{{ $t('add') }} {{ $tc('city', 2) }}</div>
      <router-link class="btn-blue" to="organizations">{{ $tc('city', 2) }} {{ $tc('list', 2) }}</router-link>
    </div>
    <div class="edit-movie-container">
      <form>
        <div class="row">
          <!-- CINEMAS SELECTION -->
          <div
            v-for="(item, index) in Cities"
            :key="index"
            v-if="item.fieldname !== 'city_id'"
            class="col-md-6 mb-4"
          >
            <div v-if="item.type !== 'radio' && item.type !== 'dropdown'">
              <div class="d-flex align-items-center">
                <div class="input-material">
                  <!-- @focus="onFocusHandler" -->
                  <!-- :required="item.required" -->
                  <input
                    @focus="onFocusHandler"
                    :type="item.type"
                    :name="item.fieldname"
                    :id="item.fieldname"
                    v-validate="item.validation"
                    v-model="item.fieldvalue"
                  />
                  <label>{{ $tc(item.label, 1)}}</label>
                </div>
                <Tooltip :title="$t(item.tooltip)" />
              </div>
              <p
                v-if="submitted && errors.has(item.fieldname)"
                class="error_message"
              >{{ errors.first(`${item.fieldname}`) }}</p>
            </div>
            <div v-if="item.type === 'radio'" class="row">
              <div class="col-md-3 col-xl-2">
                <label>{{ $t('active') }}</label>
              </div>
              <div class="col-md-9 col-xl-10">
                <div>
                  <label class="ios-switch">
                    <input type="checkbox" class="ios-checkbox" v-model="item.fieldvalue" />
                    <span class="switch-slider"></span>
                  </label>
                </div>
              </div>
            </div>

            <div v-if="item.type === 'dropdown'" class="col-md-6 mb-4">
              <div v-if="item.fieldname === 'country_id'">
                <div class>
                  <label>{{ $tc(item.label, 1) }}</label>
                </div>
                <div class>
                  <b-dropdown :text="item.dropdownSelected" variant="dropdown-curve" class="w-100">
                    <!-- _getCountryList(item.label, null) -->
                    <b-dropdown-item
                      v-for="(dropdownItem,dropdownIndex) in countryList"
                      :key="dropdownIndex"
                      href="#"
                      @click="onDropdownChange($event, item.label, dropdownItem, index)"
                    >{{ dropdownItem.country_name }}</b-dropdown-item>
                  </b-dropdown>
                  <p v-if="submitted" class="error_msg">Title cannot be empty</p>
                </div>
              </div>
              <div v-if="item.fieldname === 'state_id'">
                <div class>
                  <label>{{ $tc(item.label, 1) }}</label>
                </div>
                <div class>
                  <b-dropdown :text="item.dropdownSelected" variant="dropdown-curve" class="w-100">
                    <!-- _getCountryList(item.label, null) -->
                    <b-dropdown-item
                      v-for="(dropdownItem,dropdownIndex) in stateList"
                      :key="dropdownIndex"
                      href="#"
                      @click="onDropdownChange($event, item.label,dropdownItem, index)"
                    >{{ dropdownItem.state_name }}</b-dropdown-item>
                  </b-dropdown>
                  <p v-if="submitted" class="error_msg">Title cannot be empty</p>
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-12 text-center mt-4">
            <button class="btn-blue" @click.prevent.stop="handleSubmit(true)">{{ $t('save') }}</button>
            <button
              @click.prevent.stop="handleSubmit(false)"
              type="submit"
              class="btn-blue"
            >{{ $t('saveaddmore') }}</button>
            <button class="btn-black">{{ $t('reset') }}</button>
            <b-button class="btn-outline-grey" variant="default" to="states">{{ $t('cancel') }}</b-button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import Cities from "@/helper/formJSONMaster/Cities";

export default {
  data() {
    return {
      Cities: Cities.ms_cities,
      submitted: false,
      Methods: Cities.Methods,
      countryList: [],
      stateList: []
    };
  },
  beforeMount() {
    this.getCountryList();
    this.resetHandler();
  },
  mounted() {
    console.log("Cities :", Cities);
  },
  methods: {
    onFocusHandler: function() {
      // this.submitted = false;
    },
    getStateList: function(id) {
      this.stateList = [];
      let body = this.getRequestBody("GET", undefined, {
        GET: "/admin/tablelist/",
        tableName: "ms_states",
        params: { id: "country_id-" + id }
      });
      MasterService.GlobalRequest(body)
        .then(response => {
          const { data } = response;
          console.log("data :", data);
          if (data.status && data.Records.length > 0) {
            this.stateList = data.Records;
            this.Cities.map(x => {
              if (x.fieldname === "state_id") {
                x.dropdownSelected = "Select State";
                x.fieldvalue = "";
              }
            });
          } else {
            // Show Errors
            console.log("show error :", data.message);
          }
        })
        .catch(error => {
          // Show Catch Error
          console.log("show error :", error);
        });
    },
    getCountryList: function() {
      let body = this.getRequestBody("GET", undefined, {
        GET: "/admin/",
        tableName: "ms_countries"
      });
      MasterService.GlobalRequest(body)
        .then(response => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.countryList = data.Records;
          } else {
            console.log("show error1 :", data.message);
          }
        })
        .catch(error => {
          console.log("show error2 :", error);
        });
    },
    onDropdownChange: function(event, type, item, mainIndex) {
      // this.States[mainIndex].fieldvalue = item.country_name;
      // console.log("item :", item);

      if (type === "country") {
        this.Cities[mainIndex].fieldvalue = item.country_id;
        this.Cities[mainIndex].dropdownSelected = item.country_name;
        this.getStateList(item.country_id);
      } else if (type === "state") {
        this.Cities[mainIndex].dropdownSelected = item.state_name;
        this.Cities[mainIndex].fieldvalue = item.state_id;
      }
    },
    resetHandler: function() {
      this.Cities.map(x => {
        if (x.type === "text" || x.type === "date") {
          x.fieldvalue = "";
        } else if (x.type === "dropdown") {
          x.fieldvalue = "";
          x.dropdownSelected = "select";
        } else if (x.type === "radio") {
          x.fieldvalue = true;
        }
      });
    },
    handleSubmit(flag) {
      this.submitted = false;

      console.log("call submit :");
      this.$validator.validate().then(valid => {
        console.log("valid :", valid);
        if (valid) {
          console.log("valid :", valid);
          let body = this.getRequestBody("POST", this.Cities, this.Methods);
          console.log("body :", body);

          MasterService.GlobalRequest(body)
            .then(response => {
              const { data } = response;
              if (data.status) {
                this.resetHandler();
                if (flag) {
                  this.$router.push({
                    path: "/master/organizations"
                  });
                }
              } else {
                console.log("show error1 :", data.message);
              }
            })
            .catch(error => {
              console.log("show error2 :", error);
            });
        } else {
          this.submitted = true;

          console.log("else :");
        }
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/MasterContainer/OrganizationComponents/addOrganization.vue